import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const Team = () => {
  const { isDarkMode } = useTheme();

  // Team member data
  const teamMembers = [
    {
      name: 'Ana Rodriguez',
      fullName: 'Ana Rodriguez Sanchez-Archidona, PhD',
      role: 'Chargé de recherche',
      affiliations: [
        'CHUV/UNIL | Department of Oncology | George Coukos group',
        'Ludwig Institute for Cancer Research | Lausanne Branch'
      ],
      address: 'AGORA, Bugnon 25A, 1005 Lausanne (Switzerland), 4th floor, Room 190',
      email: 'arsanchezarchidona@gmail.com',
      secondaryEmail: 'ana.rodriguezsanchez-archidona@unil.ch',
      linkedin: 'https://www.linkedin.com/in/ana-rodríguez-sánchez-archidona-89467543/',
      portrait: '/images/AR_Portrait_light.jpg'
    },
    {
      name: 'Isaac Crespo',
      fullName: 'Isaac Crespo, PhD',
      role: 'Senior Computational Scientist',
      affiliations: [
        'CHUV/UNIL | Department of Oncology | George Coukos group',
        'Ludwig Institute for Cancer Research | Lausanne Branch'
      ],
      address: 'AGORA, Bugnon 25A, 1005 Lausanne (Switzerland), 4th floor, Room 026',
      email: 'isaaccrespo@hotmail.com',
      secondaryEmail: 'isaac.crespo@unil.ch',
      linkedin: 'https://www.linkedin.com/in/icrespo/',
      portrait: '/images/IC_Portrait_light.jpg'
    }
  ];

  return (
    <div className="dashboard-page" style={{ 
      background: isDarkMode ? 'linear-gradient(135deg, #282440 0%, #1a1a2e 100%)' : 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
      color: isDarkMode ? 'white' : '#1e293b',
      paddingTop: '0',
      minHeight: '100vh'
    }}>
      <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '2rem' }}>
        {/* Header Section */}
        <div style={{ 
          marginBottom: '4rem',
          paddingTop: '2rem'
        }}>
          {/* Centered Title */}
          <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
            <h1 style={{
              fontSize: '3rem',
              fontWeight: 'bold',
              marginBottom: '1rem',
              color: '#0099FF',
              textAlign: 'center'
            }}>
              Our Team
            </h1>
          </div>
          
          {/* Subheader text - centered on the page */}
          <div style={{ 
            marginBottom: '1.5rem'
          }}>
            <p style={{
              fontSize: '1.2rem',
              color: isDarkMode ? '#B0B0B0' : '#666',
              maxWidth: '600px',
              margin: '0 auto',
              lineHeight: '1.6',
              textAlign: 'center'
            }}>
              Meet the researchers behind AI-MCP-Bio. We're passionate about advancing bioinformatics through AI integration and standardized protocols.
            </p>
          </div>
        </div>

        {/* Team Members Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
          gap: '3rem',
          marginBottom: '4rem'
        }}>
          {teamMembers.map((member, index) => (
            <div
              key={index}
              style={{
                backgroundColor: isDarkMode ? '#212129' : '#ffffff',
                borderRadius: '16px',
                padding: '2.5rem',
                boxShadow: isDarkMode 
                  ? '0 10px 30px rgba(0, 0, 0, 0.3)' 
                  : '0 10px 30px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                border: isDarkMode ? '1px solid #374151' : '1px solid #e5e7eb'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = isDarkMode 
                  ? '0 15px 40px rgba(139, 92, 246, 0.2)' 
                  : '0 15px 40px rgba(0, 123, 255, 0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = isDarkMode 
                  ? '0 10px 30px rgba(0, 0, 0, 0.3)' 
                  : '0 10px 30px rgba(0, 0, 0, 0.1)';
              }}
            >
              {/* Portrait Image */}
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '2rem'
              }}>
                <img
                  src={process.env.PUBLIC_URL + member.portrait}
                  alt={member.name}
                  style={{
                    width: '240px',
                    height: 'auto',
                    maxHeight: '300px',
                    borderRadius: '12px',
                    objectFit: 'contain',
                    border: 'none',
                    boxShadow: isDarkMode 
                      ? '0 8px 20px rgba(139, 92, 246, 0.3)' 
                      : '0 8px 20px rgba(0, 123, 255, 0.2)',
                    backgroundColor: isDarkMode ? '#1a1a2e' : '#f8f9fa'
                  }}
                />
              </div>

              {/* Name and Title */}
              <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
                <h2 style={{
                  fontSize: '1.8rem',
                  fontWeight: 'bold',
                  marginBottom: '0.5rem',
                  color: isDarkMode ? '#fff' : '#1e293b'
                }}>
                  {member.name}
                </h2>
                <p style={{
                  fontSize: '1rem',
                  color: isDarkMode ? '#B0B0B0' : '#666',
                  marginBottom: '0.25rem',
                  fontStyle: 'italic'
                }}>
                  {member.fullName}
                </p>
                <p style={{
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  color: isDarkMode ? '#8B5CF6' : '#007bff',
                  marginTop: '0.5rem'
                }}>
                  {member.role}
                </p>
              </div>

              {/* Affiliations */}
              <div style={{ marginBottom: '1.5rem' }}>
                {member.affiliations.map((affiliation, affIndex) => (
                  <p
                    key={affIndex}
                    style={{
                      fontSize: '0.95rem',
                      color: isDarkMode ? '#D1D5DB' : '#555',
                      lineHeight: '1.6',
                      marginBottom: '0.5rem',
                      textAlign: 'center'
                    }}
                  >
                    {affiliation}
                  </p>
                ))}
              </div>

              {/* Address */}
              <div style={{
                marginBottom: '1.5rem',
                padding: '1rem',
                backgroundColor: isDarkMode ? 'rgba(139, 92, 246, 0.1)' : 'rgba(0, 123, 255, 0.05)',
                borderRadius: '8px',
                border: `1px solid ${isDarkMode ? 'rgba(139, 92, 246, 0.2)' : 'rgba(0, 123, 255, 0.1)'}`
              }}>
                <p style={{
                  fontSize: '0.9rem',
                  color: isDarkMode ? '#D1D5DB' : '#555',
                  lineHeight: '1.6',
                  textAlign: 'center',
                  margin: 0
                }}>
                  📍 {member.address}
                </p>
              </div>

              {/* Contact Information */}
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem',
                alignItems: 'center'
              }}>
                {/* Primary Email */}
                <a
                  href={`mailto:${member.email}`}
                  style={{
                    color: isDarkMode ? '#66B3FF' : '#007bff',
                    textDecoration: 'none',
                    fontSize: '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    transition: 'color 0.3s ease',
                    fontWeight: '500'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = isDarkMode ? '#8B5CF6' : '#0056b3';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = isDarkMode ? '#66B3FF' : '#007bff';
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                  </svg>
                  {member.email}
                </a>

                {/* Secondary Email */}
                {member.secondaryEmail && (
                  <a
                    href={`mailto:${member.secondaryEmail}`}
                    style={{
                      color: isDarkMode ? '#66B3FF' : '#007bff',
                      textDecoration: 'none',
                      fontSize: '1rem',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      transition: 'color 0.3s ease',
                      fontWeight: '500'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.color = isDarkMode ? '#8B5CF6' : '#0056b3';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.color = isDarkMode ? '#66B3FF' : '#007bff';
                    }}
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                    </svg>
                    {member.secondaryEmail}
                  </a>
                )}

                {/* LinkedIn */}
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: isDarkMode ? '#66B3FF' : '#007bff',
                    textDecoration: 'none',
                    fontSize: '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    transition: 'color 0.3s ease',
                    fontWeight: '500',
                    padding: '0.5rem 1rem',
                    borderRadius: '8px',
                    backgroundColor: isDarkMode ? 'rgba(139, 92, 246, 0.1)' : 'rgba(0, 123, 255, 0.05)',
                    border: `1px solid ${isDarkMode ? 'rgba(139, 92, 246, 0.3)' : 'rgba(0, 123, 255, 0.2)'}`
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = isDarkMode ? '#8B5CF6' : '#0056b3';
                    e.target.style.backgroundColor = isDarkMode ? 'rgba(139, 92, 246, 0.2)' : 'rgba(0, 123, 255, 0.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = isDarkMode ? '#66B3FF' : '#007bff';
                    e.target.style.backgroundColor = isDarkMode ? 'rgba(139, 92, 246, 0.1)' : 'rgba(0, 123, 255, 0.05)';
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                    </svg>
                    See on LinkedIn
                  </a>
              </div>
            </div>
          ))}
        </div>

        {/* Contact Section */}
        <div style={{
          backgroundColor: isDarkMode ? '#212129' : '#ffffff',
          borderRadius: '16px',
          padding: '3rem',
          textAlign: 'center',
          marginTop: '4rem',
          border: isDarkMode ? '1px solid #374151' : '1px solid #e5e7eb',
          boxShadow: isDarkMode 
            ? '0 10px 30px rgba(0, 0, 0, 0.3)' 
            : '0 10px 30px rgba(0, 0, 0, 0.1)'
        }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: 'bold',
            marginBottom: '1rem',
            color: isDarkMode ? '#8B5CF6' : '#007bff'
          }}>
            Get in Touch
          </h2>
          <p style={{
            fontSize: '1.1rem',
            color: isDarkMode ? '#D1D5DB' : '#666',
            lineHeight: '1.6',
            marginBottom: '2rem',
            maxWidth: '600px',
            margin: '0 auto 2rem auto'
          }}>
            Have questions about AI-MCP-Bio? Want to collaborate or learn more about our research? 
            We'd love to hear from you!
          </p>
          <div style={{
            display: 'flex',
            gap: '1rem',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <a
              href="mailto:isaaccrespo@hotmail.com"
              style={{
                backgroundColor: isDarkMode ? '#8B5CF6' : '#007bff',
                color: 'white',
                padding: '1rem 2rem',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '1rem',
                transition: 'all 0.3s ease',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = isDarkMode 
                  ? '0 8px 20px rgba(139, 92, 246, 0.4)' 
                  : '0 8px 20px rgba(0, 123, 255, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
              </svg>
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;

